<template>
  <base-card @close="close">
    <div id="adjustment-creation-wrapper">
      <heading heading="Add Adjustment" />
      <div id="adjustment-inputs">
        <Input
          class="scs-input"
          heading="Adjustment Name"
          placeholder="Adjustment Name"
          :initialValue="subject.name"
          @scs-input="nameInput"
        />
        <div id="switch-group">
          <binary
            class="adjustment-switch"
            heading="Type"
            option1="percentage"
            option2="dollar"
            :selected="subject.type"
            :formatter="toggleFormatter"
            @toggle="toggleType"
          />
          <binary
            class="adjustment-switch"
            heading="Charge / Discount"
            option1="charge"
            option2="discount"
            :selected="subject.direction"
            :formatter="toggleFormatter"
            @toggle="toggleDirection"
          />
        </div>
        <Input
          class="scs-input"
          :heading="subject.type === 'percentage' ? 'Amount (%)' : 'Amount'"
          type="number"
          :initialValue="subject.amount"
          placeholder="20"
          @scs-input="amountInput"
        />
      </div>
      <div class="button-container">
        <Button text="Back" @click="close" /><Button
          text="Next"
          @click="next"
        />
      </div></div
  ></base-card>
</template>
<script>
import Button from "@/Components/UI/Button.vue";
import Heading from "@/Components/UI/Heading.vue";
import BaseCard from "@/Components/UI/FloatingCards/BaseFloatingCard.vue";
import Input from "@/Components/Elements/Input.vue";
import Binary from "@/Components/Elements/Binary.vue";

export default {
  data() {
    return {
      subject: {
        id: "adjustment" + new Date().getTime(),
        name: undefined,
        direction: "charge",
        type: "percentage",
        amount: undefined,
      },
    };
  },
  methods: {
    next() {
      this.addAdjustment();
    },
    close() {
      this.$emit("close");
    },
    async addAdjustment() {
      if (this.subject.type === "percentage") {
        this.subject.amount *= 0.01;
      } else {
        this.subject.amount *= 100;
      }
      this.$emit("add-adjustment", this.subject);
    },
    nameInput(value) {
      this.subject.name = value;
    },
    toggleType(value) {
      this.subject.type = value;
    },
    toggleDirection(value) {
      this.subject.direction = value;
    },
    toggleFormatter(value) {
      return value[0].toUpperCase() + value.substring(1);
    },
    amountInput(value) {
      this.subject.amount = value;
    },
  },
  components: {
    BaseCard,
    Button,
    Heading,
    Input,
    Binary,
  },
  created() {
    if (this.adjustment) {
      this.subject = { ...this.adjustment };
      if (this.subject.type === "percentage") {
        this.subject.amount *= 100;
      }
      if (this.subject.type === "dollar") {
        this.subject.amount *= 0.01;
      }
    }
  },
  props: ["adjustment", "mode"],
  emits: ["close", "add-adjustment"],
};
</script>
<style scoped>
@media screen {
  .button-container {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }

  .scs-button {
    margin: 5px;
  }

  #adjustment-inputs {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 0 0 30px;
  }

  .scs-input {
    width: 100%;
    margin: 20px 0;
  }

  #switch-group {
    display: flex;
    flex-direction: column;
  }

  .adjustment-switch {
    margin: 0 30px;
  }
  @media (min-width: 800px) {
    #adjustment-creation-wrapper {
      width: 70vw;
    }

    .scs-input {
      width: 300px;
    }

    #switch-group {
      flex-direction: row;
    }
  }
}
</style>
